var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"nav_bg",attrs:{"src":_vm.baseUrl + _vm.bannerImg,"alt":""}}),_c('p',{staticClass:"nav_bg_text"},[_vm._v(" 合作协议 ")]),_c('div',{staticClass:"contain_charge"},[_c('div',{staticClass:"contain_content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.chargeImg)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }